import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Subject } from 'rxjs';
import {
  startWith,
  catchError,
  distinctUntilChanged,
  switchMap,
  map,
  tap,
  takeUntil,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { PermissionService } from '@app/core/auth/services/permission.service';
import { ClientUsersService } from '@app/core/client/services/client-users.service';
import { CompanyService } from '@app/core/client-user';
import { RfqService } from '@app/core/quotes';
import { RfqConversionRulesService } from '@app/core/quotes/services/rfq-conversion-rules.service';
import { UnitConversionRuleService } from '@app/core/unit-measurement/services/unit-conversion-rule/unit-conversion-rule.service';
import { UnitConversionRuleType } from '@app/modules/unit-measurement/interfaces/unit-measurement.interface';

import { RfqUnitOfConversionsPopupFormComponent } from '../rfq-unit-of-conversions-popup-form/rfq-unit-of-conversions-popup-form.component';

@Component({
  selector: 'cnc-rfq-unit-of-conversions',
  templateUrl: './rfq-unit-of-conversions.component.html',
  styleUrls: ['./rfq-unit-of-conversions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RfqUnitOfConversionsComponent implements OnInit, OnDestroy {
  @Input() rfq;

  private params :any = {
    limit: 10,
    page: 1,
  };

  pageSizeOptions :number[] = [10, 25, 100];

  rfqConversionRules :any = { data: [] };

  filter :any = {};

  subscription :Subscription;

  unitConversionRuleType :any = UnitConversionRuleType;

  private onDestroy$ = new Subject();

  constructor(
    private modalSvc :NgbModal,
    private cd :ChangeDetectorRef,
    private toastr :ToastrService,
    public UserPermission :PermissionService,
    public rfqConversionRulesService :RfqConversionRulesService,
    private unitConversionRuleService :UnitConversionRuleService,
  ) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
    this.subscription.unsubscribe();
  }

  ngOnInit() :void {
    this.getRecords(false, 1);

    this.subscription =
      this.rfqConversionRulesService.rfqConversionRules$.subscribe((records) => {
        this.rfqConversionRules = records;
        this.cd.detectChanges();
      });
  }

  getRecords(event ?:any, page ?:number) :void {
    if (page) {
      this.params.page = page;
    }

    this.params = Object.assign(this.params, this.filter);
    this.params = Object.entries(this.params).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {},
    );

    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.limit = event.pageSize;
    }

    if (this.rfq) {
      this.params.rfqId = this.rfq?.id;
    }

    this.rfqConversionRulesService.setParams(this.params);
    this.rfqConversionRulesService.refreshList();
  }

  addRfqConversionRules() :void {
    const modalRef = this.modalSvc.open(RfqUnitOfConversionsPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.rfq = this.rfq;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.rfqConversionRulesService.refreshList();
        }
      },
      (error) => {},
    );
  }

  editRfqConversionRules(rfqConversionRule :any) :void {
    const modalRef = this.modalSvc.open(RfqUnitOfConversionsPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.rfqConversionRule = rfqConversionRule;
    modalRef.componentInstance.rfq = this.rfq;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.rfqConversionRulesService.refreshList();
        }
      },
      (error) => {},
    );
  }

  deleteRfqConversionRules(rfqConversionRule :any) :void {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete rfq conversion rule?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.unitConversionRuleService
          .delete(rfqConversionRule.id)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((resp :any) => {
            this.getRecords(false, 1);
            this.toastr.success(
              'Successfully deleted rfq conversion rule.',
              'Success',
            );
          });
      }
    });
  }
}
